Common.Views.DetailedNotify = Common.Views.Notify.extend({
	className: 'b-notify b-notify--detailed',
	partials: {},

	notifyHeight: null,
	notifyWidth: null,
	imageWidth: null,

	events: {
		'click .js-notify-close': 'remove'
	},

	render: function(params) {
		this.delegateEvents();

		this.$el
			.html(this.template(_.extend(params, {
				isDetailed: true
			})))
			.appendTo(Common.view.partials.$notify);

		this.notifyHeight = this.$el.height();
		this.notifyWidth = this.$el.width();
		this.imageWidth = this.$el.find('.js-notify-image').width();

		this.$el.css({
			height: 0,
			width: this.imageWidth
		});

		this.partials.$message = this.$el.find('.js-notify-message');
		
		this.partials.$message.css('opacity', 0);

		this.$el.animate({
			height: this.notifyHeight
		}, {
			duration: 300,
			easing: 'linear',
			complete: function () {
				this.$el.animate({
					width: this.notifyWidth
				}, {
					duration: 300,
					easing: 'linear',
					complete: function () {
						this.partials.$message.animate({
							opacity: 1
						}, {
							duration: 200,
							easing: 'linear'
						});
					}.bind(this)
				});
			}.bind(this)
		});
	},

	show: function(params) {
		if (!this.timeoutInterval) {
			this.render(params);
			if (params.delay !== Infinity) {
				this.timeoutInterval = setTimeout(this.remove.bind(this), params.delay || this.delay);
			}
		}
	},

	remove: function() {
		this.undelegateEvents();

		this.timeoutInterval = null;

		if (this.partials.$message) {
			this.partials.$message.animate({
				opacity: 0
			}, {
				duration: 200,
				easing: 'linear',
				complete: function () {
					this.$el.animate({
						width: this.imageWidth
					}, {
						duration: 300,
						easing: 'linear',
						complete: function () {
							this.$el.animate({
								height: 0
							}, {
								duration: 300,
								easing: 'linear',
								complete: function () {
									this.$el
										.removeAttr('style')
										.remove();
								}.bind(this)
							});
						}.bind(this)
					});
				}.bind(this)
			});
		}
	}
});
